import React, { useState } from 'react';
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import SvgIcon from '../Helpers/Svg/SvgIcon';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';
import { lighten, makeStyles } from "@material-ui/core/styles";
import MenuIcon from '@material-ui/icons/Menu';
import CustomerSupportPhone from '../Account/CustomerSupportPhone';
import NavbarUrlManager from './NavbarUrlManager';
import ContactHelpIcon from '../../icons/contactHelp.svg';
import CustomerSupportEmail from '../Account/CustomerSupportEmail';

import './Navbar.scss';

export default function NavbarHeader() {
  let navbarLogoUrl;
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const phone = accountObj.account.phone;
  const primaryColor = accountObj.accountOverrides ? accountObj.accountOverrides[0].primaryColor : accountObj.account.primaryColor || "#4C4C4C";
  const needsAnalysisDisabled = !accountObj || (accountObj && !accountObj.enableNeedsAnalysis);
  const disableLogoLink = accountObj && accountObj.account && accountObj.account.disableLogoLink;
  const disableCompareMenu = accountObj && accountObj.account && accountObj.account.disableCompareMenu;
  const home = document.location.pathname === '/';
  const navbarUrlManager = NavbarUrlManager(accountObj.account.domain);
  const navbarUrl = navbarUrlManager.url;
  const partnerContactInformation = isValidJSON(accountObj.account.partnerContactInformation) ? JSON.parse(accountObj.account.partnerContactInformation) : null;
  const isStandAlone = navbarUrlManager.isStandAlone;
  const [expanded, setExpanded] = useState(false);
  if (accountObj && accountObj.account && accountObj.account.logoUrl) {
    if (home && accountObj.account.logoUrlHome) {
      navbarLogoUrl = accountObj.accountOverrides ? accountObj.accountOverrides[0].homeLogoUrl : accountObj.account.logoUrlHome;
    } else {
      navbarLogoUrl = accountObj.accountOverrides ? accountObj.accountOverrides[0].landingLogoUrl : accountObj.account.logoUrl;
    }
  } else {
    if (home) {
      navbarLogoUrl = '/logos/covr-logo-white.svg';
    } else {
      navbarLogoUrl = '/logos/covr-logo.svg';
    }
  }

  const useStyles = makeStyles(() => ({
    transparent: {
      position: 'absolute',
      zIndex: 2,
      boxShadow: 'none',
    },
    bigLogo: {
      width: 'auto',
      height: '55px',
      backgroundSize: 'contain',
      margin: '20px 0',
    },
    normalLogo: {
      width: 'auto',
      height: '50px',
      backgroundSize: 'contain',
      marginLeft: '20px',
    },
    header: {
      color: 'white',
      fontWeight:'bold',
    },
    primaryColorText: {
      color: primaryColor,
    },
    primaryColorBackground: {
      backgroundColor: primaryColor,
    },
    hoverPrimaryColor: {
      "&:hover, &:focus": {
        backgroundColor: lighten(primaryColor, 0.92) + "!important",
        outlineColor: lighten(primaryColor, 0.75) + "!important",
        outlineStyle: "solid !important",
        outlineWidth: 2 + "!important",
        outlineOffset: -2,
      },
    }
  }));

  const classes = useStyles();

  const phoneNumber = CustomerSupportPhone();
  const emailAddress = CustomerSupportEmail();

  const { domain } = accountObj.account;
  const isEtradeNav = (domain.toLowerCase().indexOf("etrade") !== -1 || domain.toLowerCase().indexOf("msatwork") !== -1);
  
  function isValidJSON(value) {
    if (typeof value !== "string") {
      return false;
    };

    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return false;
    };
  };

  return (
    <div role="banner">
      <Navbar id="navbar" expand="md" variant={home ? 'dark' : 'light'} className={home ? classes.transparent : ''}>

        <Navbar.Brand className="mr-auto">
          {!disableLogoLink ?
            <div className="logo">
              <a href={navbarUrl}><img src={navbarLogoUrl} className={home ? classes.bigLogo : classes.normalLogo} alt={`${accountObj.account.accountName || 'Covr'}`} /></a>
              { !isEtradeNav && <a href={`tel:${phone}`}><span className={`account-phone  ${classes.header}`}>{phone}</span></a> }
            </div>
            :
            <div className="logo">
              <img src={navbarLogoUrl} className={home ? classes.bigLogo : classes.normalLogo} alt={`${accountObj.account.accountName || 'Covr'}`} />
              { !isEtradeNav && <span className={`account-phone ${classes.header}`}>{phone}</span> }
            </div>
          }
        </Navbar.Brand>

        { !isEtradeNav && <Navbar.Toggle className='button-text' aria-controls="basic-navbar-nav" aria-expanded={expanded} onClick={() => setExpanded(!expanded)} >
          <MenuIcon fontSize="large" />
        </Navbar.Toggle> }

        <Navbar.Collapse id="basic-navbar-nav" className={isEtradeNav ? "no-collapse show" : ""}>
          <Nav defaultActiveKey="/">
            {!isStandAlone && !disableCompareMenu && !isEtradeNav && (
              <NavDropdown title="Explore" id="compare-dropdown" role="menu" >
                {accountObj && accountObj.accountProducts && accountObj.accountProducts.map((product, index) =>
                  <NavDropdown.Item key={index} href={product.productLandingUrl} target={product.openInNewTab ? "_blank" : "_self"} role="menuitem">
                    <div className="d-flex align-items-center">
                      <SvgIcon iconName={product.productIconPath} /> {product.displayName}
                    </div>
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            )}
            {!needsAnalysisDisabled && <Nav.Link href="#">Calculate</Nav.Link>}

            { isEtradeNav && <div className="phone-container">
              <p className={classes.primaryColorText}><SvgIcon color={primaryColor} iconName="phoneCall" fontSize="medium"/>{phoneNumber}</p>
            </div> }

            <NavDropdown title={isEtradeNav ? <ContactHelpIcon /> : "Contact"} id="contact-dropdown" className={isEtradeNav ? `contact-dropdown minimal ${classes.primaryColorBackground}` : "contact-dropdown"} role="menu">
              <div className="contact-container">
                <NavDropdown.Item className={classes.hoverPrimaryColor} href={`tel:${phoneNumber}` } role="menuitem">
                  <div className="d-flex stack">
                    <h3>Call us at:</h3> 
                    <p className={isEtradeNav ? `emphasize ${classes.primaryColorText}` : ""}>{phoneNumber}</p>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item className={classes.hoverPrimaryColor} href={`mailto:${emailAddress}`} role="menuitem">
                  <div className="d-flex stack">
                    <h3>Email us at:</h3> 
                    <p className={isEtradeNav ? `emphasize ${classes.primaryColorText}` : ""}>{emailAddress}</p>
                  </div>
                </NavDropdown.Item>
                <NavDropdown.Item href="#" className="non-clickable" role="menuitem">
                  <div className="d-flex stack">
                    <h3>Hours of Operation:</h3>
                    <p className='compress'>Monday - Friday<br/>8:00 AM ET to 8:00 PM ET</p>
                  </div>
                </NavDropdown.Item>
              </div>
              { partnerContactInformation && 
              <div className="contact-container partner">
                { partnerContactInformation.phoneNumber && <NavDropdown.Item className={classes.hoverPrimaryColor} href={`tel:${partnerContactInformation.phoneNumber.number}` } role="menuitem">
                  <div className="d-flex stack">
                    <h3>Call {accountObj.account.accountName} at:</h3> 
                    <p className={isEtradeNav ? `emphasize ${classes.primaryColorText}` : ""}>{partnerContactInformation.phoneNumber.display}</p>
                  </div>
                </NavDropdown.Item> }
                { partnerContactInformation.emailAddress && <NavDropdown.Item className={classes.hoverPrimaryColor} href={`mailto:${partnerContactInformation.emailAddress.link}`} role="menuitem">
                  <div className="d-flex stack">
                    <h3>Email {accountObj.account.accountName} at:</h3> 
                    <p className={isEtradeNav ? `emphasize ${classes.primaryColorText}` : ""}>{partnerContactInformation.emailAddress.display}</p>
                  </div>
                </NavDropdown.Item> }
                { partnerContactInformation.website && <NavDropdown.Item className={classes.hoverPrimaryColor} href={`${partnerContactInformation.website.link}`} target="_blank" role="menuitem">
                  <div className="d-flex stack">
                    <h3>Visit {accountObj.account.accountName} at:</h3> 
                    <p className={isEtradeNav ? `emphasize ${classes.primaryColorText}` : ""}>{partnerContactInformation.website.display}</p>
                  </div>
                </NavDropdown.Item> }
              </div>}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div >
  );
}



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js